<template>
    <div class="main_container">
        <Header></Header>
        <div style="flex:1;overflow: auto;">
            <router-view></router-view>
        </div>
        <Footer></Footer>
    </div>

</template>
<script>
import Header from './header'
import Footer from './footer'
export default {
    mixins: [],
    name: "mainPage",
    components: {
        Header,
        Footer
    },
    beforeRouteLeave(to, from, next) {

    },
    data() {
        return {

        };
    },
    async beforeCreate() {

    },
    async created() {

    },
    async beforeMount() {},
    mounted() {
    },
};
</script>
<style lang="scss" scoped>
.main_container{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column
}
</style>
